












import { IGiftTipsItem } from "@/api/types";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Tween } from "@tweenjs/tween.js";
@Component
export default class GiftTips extends Vue {
  @Prop()
  giftTips!: IGiftTipsItem[];

  showTipsItem: IGiftTipsItem | null = null;

  showNum = 0;

  numTimer?: number;

  hide = false;

  out = false;

  get list() {
    return this.giftTips.map(item => item);
  }

  showTips: IGiftTipsItem[] = [];

  @Watch("list")
  watchList(nv: IGiftTipsItem[], ov: IGiftTipsItem[]) {
    const diff = nv.slice(ov.length);
    this.showTips = this.showTips.concat(diff);
  }

  mounted() {
    this.getNextItem();
  }

  getNextItem() {
    this.showNum = 0;
    this.showTipsItem = this.showTips[0];
    if (this.showTipsItem) {
      this.hide = false;
      this.numAnimation(this.showTipsItem.sum).then(() => {
        setTimeout(() => {
          this.hide = true;
        }, 1000);
        setTimeout(() => {
          this.showTipsItem = null;
          this.showTips.splice(0, 1);
          this.$emit("removeGiftTips", this.showTips.length);
        }, 1500);
        setTimeout(() => {
          if (!this.out) {
            this.getNextItem();
          }
        }, 2000);
      });
    } else {
      setTimeout(() => {
        if (!this.out) {
          this.getNextItem();
        }
      }, 1000);
    }
  }

  numAnimation(num: number) {
    return new Promise(resolve => {
      const t = new Tween({ number: this.showNum })
        .to({ number: num }, 1000)
        .onUpdate(tween => {
          this.showNum = Number(tween.number.toFixed(0));
        })
        .start();
      const animate = () => {
        if (t.update()) {
          requestAnimationFrame(animate);
        } else {
          resolve(true);
        }
      };
      animate();
    });
  }

  beforeDestroy() {
    this.out = true;
  }
}
